import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsArrow1 = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <path
        fill="currentColor"
        d="M15.418601,3.9757948c0.3094931,0.0003104,0.6056681,0.1259389,0.8210001,0.3482409
		l6.8669758,6.8649244c0.4460945,0.4468412,0.4460945,1.1705265,0,1.6173677l-6.8669758,6.8649254
		c-0.4368429,0.4564037-1.160964,0.4722614-1.6173687,0.0354176c-0.4564037-0.4368458-0.4722614-1.1609631-0.0354185-1.6173668
		c0.0115461-0.012064,0.0233564-0.0238724,0.0354185-0.0354195l4.9116306-4.9116297H1.7031208
		c-0.6319621,0-1.1442685-0.5123053-1.1442685-1.144269c0-0.6319628,0.5123065-1.144268,1.1442685-1.144268h17.8327923
		l-4.9116297-4.9116287c-0.4541798-0.4391541-0.466363-1.1633458-0.0272102-1.6175275
		C14.8123999,4.1018691,15.1088305,3.976023,15.418601,3.9757948z"
      />
    </SvgIcon>
  );
});

export default AppIconsArrow1;
